import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { InstalledApplicationsEffects } from './installed-applications.effects';
import { installedApplicationsReducer } from './installed-applications.reducer';

export const provideInstalledApplicationsStore = () => [
  provideState('installed-applications', installedApplicationsReducer),
  provideEffects([InstalledApplicationsEffects]),
];
